import React, { Component } from "react";

import { Icon } from "@mui/material";
import env from "../../../env";

import FacebookBot from "../../components/FacebookBot";
import TelegramBot from "../../components/TelegramBot";
import Text from "../../components/Text";

import "./Communication.styl";

class Communication extends Component {
    render() {
        return (
            <div tabIndex={0} aria-label="Conteúdo da Página Canais de Comunicação" className="Communication">
                <section id="presentation" className="frame padded flex ai-c" aria-label="Apresentação dos canais de comunicação" style={{ backgroundImage: `url(${env.images.communication})`}}>
                    <div className="darken">
                        <Text className="header align-center flex ai-c jc-c" as="h1"><Icon className="icon">perm_phone_msg</Icon>Canais de Comunicação</Text>
                        <Text className="align-center">Conheça os canais de comunicação disponíveis para facilitar o contato com sua equipe de suporte.</Text>
                    </div>
                </section>
                <section id="the-text" className="dark image frame padded equally">
                    <div className="flex ai-c jc-c">
                        <div className="description">
                            <Text className="header desktop" as="h2"><Icon className="header-icon">perm_phone_msg</Icon>Por que usar nossos canais?</Text>
                            <Text className="text">
                                Os canais de comunicação Geolux permitem que os munícipes consigam, de
                                forma fácil e simples, comunicar e acompanhar problemas ocorridos na
                                iluminação pública do município. Aproveitando uma tendência mundial de uso de
                                aplicativos de troca de mensagens, como o “Facebook Messenger” e “Telegram“,
                                os canais aproximam a prefeitura e o cidadão de uma forma muito eficaz.
                            </Text>
                            <div className="virtual-attendants">
                                <FacebookBot />
                                <TelegramBot />
                            </div>
                            <Text className="text">
                                Com funcionamento 24 horas, de forma totalmente automatizada, nossa solução
                                permite um atendimento rápido e objetivo ao munícipe, permitindo que o mesmo
                                consiga em poucos segundos registrar uma solicitação ou até mesmo consultar o
                                andamento de uma solicitação registrada anteriormente.
                            </Text>
                            <div className="self-service flex jc-c ai-c">
                                <img src={env.images.selfServiceWebsiteSmall} alt="Site de autoatendimento de Aracajú (recortado)" />
                            </div>
                            <Text className="text">
                                Além disso, o uso desta solução trás o controle das solicitações para as
                                prefeituras, de forma independente das empresas que realizam a gestão ou
                                manutenção da iluminação pública, podendo estas ter seus sistemas integrados
                                com os canais Geolux para receber ou encerrar as solicitações.
                            </Text>
                            <div className="in-field-operations flex jc-c ai-c">
                                <img src={env.images.cityHall.inFieldOperations} alt="Três celulares mostrando diferentes páginas do aplicativo do Geolux para equipes de suporte." />
                            </div>
                            <Text className="text">
                                Para maiores informações e contratação da nossa solução, entrar em contato
                                através do email: <a href="mailto:geolux@sumersoft.com">geolux@sumersoft.com</a>
                            </Text>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default Communication;
